import React from "react";

import styles from "./pageTitle.scss";

const PageTitle = ({ title, className }) => (
  <h1 className={`${styles.title} ${className}`}>{title}</h1>
);

PageTitle.defaultProps = { className: "" };

export default PageTitle;



// WEBPACK FOOTER //
// ./src/routes/Admin/PageTitle/PageTitle.tsx